import type {
  ActionTendencyProfile,
  CompanionAffinityProfile,
  CompanionType,
  MotivationType,
  PreferenceProfile,
  TendencyAxis,
  TendencyDimensionProfile,
} from './types'

const tendencyAxes: TendencyAxis[] = ['interaction', 'information', 'judgment', 'approach']
const companionTypes: CompanionType[] = ['lion', 'eagle', 'snake', 'dog']
const motivationTypes: MotivationType[] = ['exploration', 'discovery', 'expression', 'competition']

const neutralTendency = (): TendencyDimensionProfile => ({
  score: 0,
  band: 3,
  confidence: 0,
  evidenceCount: 0,
  evidence: [],
})

export function createNeutralPreferenceProfile(
  presentation: PreferenceProfile['presentation'] = { narrative: 0, visual: 0, verbal: 0, taskBased: 0 },
): PreferenceProfile {
  return {
    presentation,
    interests: [],
    rewardPreferences: [],
    tendencies: Object.fromEntries(tendencyAxes.map((axis) => [axis, neutralTendency()])) as ActionTendencyProfile,
    motivations: Object.fromEntries(motivationTypes.map((type) => [type, 0])) as Record<MotivationType, number>,
    companionAffinity: {
      scores: Object.fromEntries(companionTypes.map((type) => [type, 0])) as Record<CompanionType, number>,
      recommended: [],
      selected: null,
      confidence: 0,
    } satisfies CompanionAffinityProfile,
  }
}
